import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { getUserElections } from '../../../service/election';
import { useUserStore } from '../../../store/useUser';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import useSearchParam from '../../../hooks/useQueryParams';

import styles from './Votes.module.scss'
import { Election } from '../../common/Election/Election';
import { Spin } from 'antd';

import useHeader from '../../../hooks/useHeader';

const Votes: React.FC = () => {
  const userId = useUserStore((state) => state.id);
  const [searchType, setSearchType] = useSearchParam<string, 'book'| 'meet' | ''>('type')
  const [time, setTime] = useSearchParam<string, 'today' | 'open' | 'closed' | undefined>('time')

  if(searchType == null) setSearchType('')
  
  const {data, isFetching} = useQuery(
    ['election', searchType, time],
    () => getUserElections(userId, searchType, time),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: 'Suas Votações' });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.badge}/>
        <div>Votações</div>
      </div>
      <Filter>
          <FilterItem 
            active={searchType === ''}
            onClick={e => setSearchType('')}> 
              Todos
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchType('meet')} 
            active={searchType === 'meet'}>
              Encontros
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchType('book')} 
            active={searchType === 'book'}>
              Livros
          </FilterItem>

          <FilterItem 
            active={time === 'closed'}
            onClick={e => setTime('closed')}> 
              Finalizada
          </FilterItem>
          <FilterItem 
            onClick={e => setTime('open')} 
            active={time === 'open'}>
              Aberta
          </FilterItem>
          <FilterItem 
            onClick={e => setTime('today')} 
            active={time === 'today'}>
              Hoje
          </FilterItem>
        </Filter> 

        <div className={styles.containerVotes}>
          <Spin spinning={isFetching}>
          {
            data?.map((data) => 
              <Election
                key={data?.id}
                election={data}/>
              )
          }
          </Spin>
        </div>
    </div>
  )
}

export default Votes;